import { useEffect, useState } from "react";

// Curated set of collegiate/campus photographs.
// Cycles with a slow crossfade + Ken Burns zoom for cinematic feel.
const SLIDES = [
    // Harvard — Yard in summer
    "https://commons.wikimedia.org/wiki/Special:FilePath/Harvard_Yard_im_Sommer.jpg?width=2000",
    // Columbia — Walking Through (lush trees, summer)
    "https://commons.wikimedia.org/wiki/Special:FilePath/Walking_Through_Columbia_University_(5892973734).jpg?width=2000",
    // Stanford — Main Quad in May (full sun)
    "https://commons.wikimedia.org/wiki/Special:FilePath/Stanford_University_Main_Quad_May_2011_005.jpg?width=2000",
    // Stanford — Arches with Memorial Church
    "https://commons.wikimedia.org/wiki/Special:FilePath/Stanford_University_Arches_with_Memorial_Church_in_the_background.jpg?width=2000",
    // Yale — Old Campus Courtyard + Durfee Hall (summer, students in shorts)
    "https://commons.wikimedia.org/wiki/Special:FilePath/Old_Campus_Courtyard_and_Durfee_Hall,_Yale_University,_New_Haven,_2007.jpg?width=2000",
    // Cornell — North Campus
    "https://commons.wikimedia.org/wiki/Special:FilePath/Cornell_University_-_North_Campus_area.jpg?width=2000",
    // Princeton — University Library
    "https://commons.wikimedia.org/wiki/Special:FilePath/Princeton_University_Library.jpg?width=2000",
    // Columbia — Butler Library (summer, green lawns)
    "https://commons.wikimedia.org/wiki/Special:FilePath/Butler_Library,_Columbia_University.jpg?width=2000",
];

const SLIDE_DURATION = 6000; // ms each slide stays before crossfade

export default function HeroBackgroundSlideshow() {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setActive((prev) => (prev + 1) % SLIDES.length);
        }, SLIDE_DURATION);
        return () => clearInterval(id);
    }, []);

    return (
        <div
            aria-hidden="true"
            data-testid="hero-bg-slideshow"
            style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                zIndex: 0,
            }}
        >
            {SLIDES.map((src, i) => (
                <div
                    key={src}
                    className="hero-slide"
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url("${src}")`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: i === active ? 1 : 0,
                        transition: "opacity 1600ms ease-in-out",
                        animation: i === active ? "hero-kenburns 16s ease-in-out infinite alternate" : "none",
                        willChange: "opacity, transform",
                    }}
                />
            ))}

            {/* Left-fade — lighter so it doesn't overpower the page below */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(90deg, rgba(11,28,67,0.62) 0%, rgba(11,28,67,0.45) 38%, rgba(11,28,67,0.18) 70%, rgba(11,28,67,0.02) 100%)",
                }}
            />
            {/* Subtle bottom fade to the next section background (mist) */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(232,240,254,0.0) 78%, rgba(232,240,254,0.75) 100%)",
                }}
            />
        </div>
    );
}
